import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import defaultAvatar from "../../assets/sampleAvatar.png";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function ConnectionsListModal({ token, targetUserId, initialTab, onClose, isOwnProfile = true }) {
  const [tab, setTab] = useState(initialTab || "followers");
  const [followers, setFollowers] = useState([]);
  const [following, setFollowing] = useState([]);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/getDetailedConnections`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ targetUserId }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success") {
          setFollowers(r.followers || []);
          setFollowing(r.following || []);
          setConnections(r.connections || []);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [token, targetUserId]);

  const list = tab === "followers" ? followers : tab === "following" ? following : connections;

  function resolveAvatar(av) {
    return av && av !== "sampleAvatar.png" ? av : defaultAvatar;
  }

  function handleRemove(username, userId) {
    if (tab === "following") {
      // Unfollow that user
      fetch(`${API_URL}/updateUserConnections`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ username, status: "unfollowed" }),
      })
        .then((r) => r.json())
        .then((r) => { if (r.message === "success") setFollowing((prev) => prev.filter((u) => u.userID !== userId)); })
        .catch((err) => console.error(err));
    } else {
      // Remove a follower
      fetch(`${API_URL}/removeFollower`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ followerUserId: userId }),
      })
        .then((r) => r.json())
        .then((r) => { if (r.message === "success") setFollowers((prev) => prev.filter((u) => u.userID !== userId)); })
        .catch((err) => console.error(err));
    }
  }

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9999 }}
      onClick={onClose}
    >
      <div
        className="rounded-4 d-flex flex-column"
        style={{
          backgroundColor: "#1e1e2e",
          border: "1px solid #2a2a3e",
          width: "90%",
          maxWidth: "420px",
          maxHeight: "70vh",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Tabs */}
        <div className="d-flex border-bottom" style={{ borderColor: "#2a2a3e !important" }}>
          {["followers", "following"].map((t) => (
            <button
              key={t}
              className="btn flex-grow-1 py-3 rounded-0"
              onClick={() => setTab(t)}
              style={{
                color: tab === t ? "var(--main-purple)" : "#828282",
                fontWeight: tab === t ? "700" : "400",
                fontSize: "1.2rem",
                borderBottom: tab === t ? "2px solid var(--main-purple)" : "2px solid transparent",
                backgroundColor: "transparent",
                textTransform: "capitalize",
              }}
            >
              {t}
            </button>
          ))}
        </div>

        {/* List */}
        <div className="flex-grow-1 p-2" style={{ overflowY: "auto" }}>
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border spinner-border-sm text-secondary" role="status" />
            </div>
          ) : list.length === 0 ? (
            <p className="text-center py-4" style={{ color: "#828282", fontSize: "1.2rem" }}>
              No {tab} yet
            </p>
          ) : (
            list.map((user) => (
              <div
                key={user.userID}
                className="d-flex align-items-center gap-3 px-3 py-2 rounded-3"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onClose();
                  navigate(`/profile?username=${user.username}`, {
                    state: { searchPersonID: user.userID },
                  });
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <div style={{ width: 40, height: 40, minWidth: 40 }}>
                  <img
                    src={resolveAvatar(user.avatar)}
                    alt=""
                    className="rounded-circle w-100 h-100"
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <span className="text-white flex-grow-1" style={{ fontSize: "1.3rem" }}>
                  @{user.username}
                </span>
                {isOwnProfile && (
                  <button
                    className="btn btn-sm rounded-pill px-2 py-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(user.username, user.userID);
                    }}
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid #ff6666",
                      color: "#ff6666",
                      fontSize: "0.85rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {tab === "following" ? "Unfollow" : "Remove"}
                  </button>
                )}
              </div>
            ))
          )}
        </div>

        {/* Close */}
        <div className="p-2 text-center border-top" style={{ borderColor: "#2a2a3e !important" }}>
          <button
            className="btn btn-sm"
            onClick={onClose}
            style={{ color: "#828282", fontSize: "1.1rem" }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
